/** Product details belong to the contact and shipment, independently of optional gifts. */
export function productNameIssue(value: unknown, required = false): string | null {
  if (value === undefined || value === null || (typeof value === 'string' && !value.trim())) {
    return required ? 'Enter the product being shipped.' : null;
  }
  if (typeof value !== 'string') return 'Enter a product name.';
  if (value.trim().length > 200) return 'Product name must be 200 characters or fewer.';
  return null;
}
